import React, { useState, useEffect } from 'react';

const ConsentBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const savedConsent = localStorage.getItem('zap_analytics_consent');
    if (!savedConsent) {
      // Show after a short delay for better UX
      const timer = setTimeout(() => setShow(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleConsent = (type) => {
    localStorage.setItem('zap_analytics_consent', type);
    setShow(false);

    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': type,
        'ad_storage': type,
        'ad_user_data': type,
        'ad_personalization': type
      });
    }
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-6 right-6 z-[9999] max-w-sm w-full animate-in fade-in slide-in-from-bottom-5 duration-700">
      <div className="bg-slate-900 border border-white/10 p-6 rounded-3xl shadow-[0_20px_50px_rgba(0,0,0,0.5)] backdrop-blur-xl">
        <div className="flex items-start gap-4 mb-4">
          <div className="w-10 h-10 rounded-full bg-indigo-500/20 flex items-center justify-center text-indigo-400 shrink-0">
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04M12 21a11.955 11.955 0 01-8.618-3.04A11.955 11.955 0 0112 2.944a11.955 11.955 0 018.618 3.04A11.955 11.955 0 0112 21z" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-bold text-white mb-1">Privacy First</h3>
            <p className="text-slate-400 text-sm leading-relaxed">
              We use analytics to improve our tools for MTD 2026. Your data is anonymized and compliant with UK/EU laws.
            </p>
          </div>
        </div>
        
        <div className="flex flex-col gap-2">
          <button 
            onClick={() => handleConsent('granted')}
            className="w-full py-3 bg-indigo-500 hover:bg-indigo-400 text-white font-bold rounded-xl transition-all shadow-lg shadow-indigo-500/25"
          >
            Accept All
          </button>
          <button 
            onClick={() => handleConsent('denied')}
            className="w-full py-3 bg-white/5 hover:bg-white/10 text-slate-300 font-semibold rounded-xl transition-all border border-white/5"
          >
            Decline
          </button>
        </div>
        
        <p className="text-[10px] text-slate-500 mt-4 text-center">
            By clicking "Accept All", you agree to our 
            <a href="/privacy.html" className="underline ml-1">Privacy Policy</a>.
        </p>
      </div>
    </div>
  );
};

export default ConsentBanner;
